import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const ConversationApi = createApi({
  reducerPath: "ConversationApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["CONVERSATIONS"],
  endpoints: (build) => ({
    getConversations: build.query({
      query: ({ page = 1, limit = 20, status, botId } = {}) => {
        let url = `/conversations?page=${page}&limit=${limit}`;
        if (status) url += `&status=${status}`;
        if (botId) url += `&botId=${botId}`;
        return url;
      },
      providesTags: ["CONVERSATIONS"],
    }),

    getConversationById: build.query({
      query: (id) => `/conversations/${id}`,
      providesTags: ["CONVERSATIONS"],
    }),

    startConversation: build.mutation({
      query: (data) => ({
        url: `/conversations/start`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["CONVERSATIONS"],
    }),

    sendMessage: build.mutation({
      query: ({ id, data }) => ({
        url: `/conversations/${id}/message`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["CONVERSATIONS"],
    }),
  }),
});

export const {
  useGetConversationsQuery,
  useGetConversationByIdQuery,
  useStartConversationMutation,
  useSendMessageMutation,
} = ConversationApi;
